import React from 'react';

import { Text } from '@reckon-web/text';

// ActivityCategory SignOffDecline = 11
export const ActivityCategorySignOffDecline = () => (
  <Text size="small">Declined sign off</Text>
);
